import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { X } from 'lucide-react';
export function NotThisSection() {
  const items = ['No es una dieta keto extrema donde prohíbes los carbohidratos.', 'No es un plan de ayuno intermitente forzado que te hace pasar hambre.', 'No es contar calorías obsesivamente en cada comida que sirves.', 'No es eliminar el arroz, las tortillas o el pan de tu vida para siempre.', 'No es tomar pastillas, batidos o suplementos costosos cada mes.', 'No es un plan imposible de seguir si tienes familia, hijos o vida social.'];
  return <section className="py-16 md:py-20 bg-white px-4" data-id="element-308">
      <div className="max-w-3xl mx-auto" data-id="element-309">
        <FadeInSection data-id="element-310">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-311">
            Quiero ser muy claro sobre lo que ESTO NO ES...
          </h2>

          <div className="space-y-4 text-lg md:text-xl text-gray-800" data-id="element-312">
            {items.map((item, index) => <div key={index} className="flex items-start p-4 bg-red-50 rounded-lg" data-id="element-313">
                <X className="w-6 h-6 text-red-600 mr-4 flex-shrink-0 mt-1" data-id="element-314" />
                <p className="font-medium" data-id="element-315">{item}</p>
              </div>)}
          </div>

          <p className="mt-10 text-xl text-center font-bold text-green-700" data-id="element-316">
            Es simplemente aprender a usar la biología a tu favor.
          </p>
        </FadeInSection>
      </div>
    </section>;
}